"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectOrPreset = exports.StringOrList = exports.ObjectOrList = exports.ChoiceNode = void 0;
const ListNode_1 = require("./ListNode");
const SwitchNode_1 = require("./SwitchNode");
/**
 * Node that allows multiple types
 */
const ChoiceNode = (choices, config) => {
    const isValid = (choice, value) => {
        if (choice.match) {
            return choice.match(value);
        }
        switch (choice.type) {
            case 'list': return Array.isArray(value);
            case 'object': return typeof value === 'object' && !Array.isArray(value);
            default: return typeof value === choice.type;
        }
    };
    const switchNode = (0, SwitchNode_1.SwitchNode)(choices.map(c => ({
        type: c.type,
        priority: c.priority,
        match: (path) => isValid(c, path.get()),
        node: c.node
    })));
    return {
        ...switchNode,
        validate(path, value, errors, options) {
            let choice = switchNode.activeCase(path, true);
            if (choice.node.optional()) {
                return value;
            }
            return choice.node.validate(path, value, errors, options);
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.choice) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this, choices, config: config !== null && config !== void 0 ? config : {}, switchNode }, path, ...args);
        }
    };
};
exports.ChoiceNode = ChoiceNode;
const XOrList = (x) => ((node, config) => {
    return (0, exports.ChoiceNode)([
        {
            type: x,
            node,
            change: v => { var _a; return (_a = v[0]) !== null && _a !== void 0 ? _a : node.default(); }
        },
        {
            type: 'list',
            node: (0, ListNode_1.ListNode)(node),
            change: v => v ? [v] : []
        }
    ], config);
});
exports.ObjectOrList = XOrList('object');
exports.StringOrList = XOrList('string');
const ObjectOrPreset = (presetNode, objectNode, presets) => {
    return (0, exports.ChoiceNode)([
        {
            type: 'string',
            priority: 1,
            node: presetNode,
            change: v => Object.keys(presets)[0]
        },
        {
            type: 'object',
            node: objectNode,
            change: v => { var _a; return (_a = presets[v]) !== null && _a !== void 0 ? _a : presets[Object.keys(presets)[0]]; }
        }
    ]);
};
exports.ObjectOrPreset = ObjectOrPreset;
